// @flow

import React from 'react';
import UniquenessSurvey from './UniquenessSurvey';
import type { UniquenessType } from '../../../../../types/apolloType';
import { Translate } from 'react-redux-i18n';

type Props = {
  uniqueness: UniquenessType,
};

type State = {};

class DifferentiationDetailModal extends React.Component<Props, State> {
  getAllRules = (): Node[] =>
    [1, 2, 3, 4, 5].map((value) => (
      <div className="differentiation-rule">
        <div className="rule_title">
          <Translate
            value="attractiveScore.differentiation.details.rules.title"
            ruleNumber={value}
          />
        </div>
        <Translate
          value={`attractiveScore.differentiation.details.rules.rule${value}`}
        />
      </div>
    ));

  render() {
    return (
      <div className="differentiation_modal-content">
        <div className="differentiation-rules-container">
          {this.getAllRules()}
        </div>
        <div className="uniqueness-survey-container">
          <UniquenessSurvey
            i18nPath="attractiveScore.differentiation.details.product"
            notes={this.props.uniqueness.productsUniqueness}
          />
          <UniquenessSurvey
            i18nPath="attractiveScore.differentiation.details.store"
            notes={this.props.uniqueness.storesUniqueness}
          />
        </div>
      </div>
    );
  }
}

export default DifferentiationDetailModal;